import { v4 as uuid } from "uuid";
import { Tabs } from "./model";

export const getData = (tab: Tabs) => {
  switch (tab) {
    case "SKU":
      return skuData;
    case "Search Query Brand":
      return brandData;
    case "Search Query ASIN":
      return asinData;
    case "Ads Time Budget":
      return adsTimeBudgetData;
    case "Search Query Performance":
      return searchQueryPerformanceData;
    case "Search Query Product":
      return searchQueryProductData;
    case "Search Query GEOGRAPHY":
      return searchQueryGeographyData;
    case "COGS":
      return SearchQueryCOGSData;
    default:
      return skuData;
  }
};

const searchQueryGeographyData = [
  {
    regionBasedSearchVolume: "North-East",
    regionalCTR: "14%",
    competitorPresence: "High",
    localizedKeywordPerformance: "{keyword}, {keyword}, {keyword}",
  },
  {
    regionBasedSearchVolume: "South-East",
    regionalCTR: "12%",
    competitorPresence: "Medium",
    localizedKeywordPerformance: "{keyword}, {keyword}, {keyword}, {keyword}",
  },
  {
    regionBasedSearchVolume: "West Coast",
    regionalCTR: "16%",
    competitorPresence: "Low",
    localizedKeywordPerformance:
      "{keyword}, {keyword}, {keyword}, {keyword}, {keyword}, {keyword}",
  },
  {
    regionBasedSearchVolume: "Midwest",
    regionalCTR: "14%",
    competitorPresence: "Medium",
    localizedKeywordPerformance: "{keyword}, {keyword}, {keyword}",
  },
  {
    regionBasedSearchVolume: "South-West",
    regionalCTR: "13%",
    competitorPresence: "High",
    localizedKeywordPerformance: "{keyword}, {keyword}, {keyword}",
  },
];

const searchQueryProductData = [
  {
    product: "{product-name}",
    topKeywords: "{keyword}, {keyword}, {keyword}",
    keywordSalesAttribution: "70%",
    lostImpressionShare: "10%",
    buyBoxWinRate: "95%",
  },
  {
    product: "{product-name}",
    topKeywords: "{keyword}, {keyword}, {keyword}, {keyword}",
    keywordSalesAttribution: "70%",
    lostImpressionShare: "10%",
    buyBoxWinRate: "95%",
  },
  {
    product: "{product-name}",
    topKeywords:
      "{keyword}, {keyword}, {keyword}, {keyword}, {keyword}, {keyword}",
    keywordSalesAttribution: "70%",
    lostImpressionShare: "10%",
    buyBoxWinRate: "95%",
  },
  {
    product: "{product-name}",
    topKeywords: "{keyword}, {keyword}",
    keywordSalesAttribution: "70%",
    lostImpressionShare: "10%",
    buyBoxWinRate: "95%",
  },
  {
    product: "{product-name}",
    topKeywords: "{keyword}, {keyword}, {keyword}",
    keywordSalesAttribution: "70%",
    lostImpressionShare: "10%",
    buyBoxWinRate: "95%",
  },
];

const searchQueryPerformanceData = [
  {
    brandVisibilityScore: "80%",
    organicVsSponsored: "60% Organic, 40% Sponsored",
    averageCpc: "$1.20",
    clickShare: "15%",
    historicalTrends: "Stable",
  },
  {
    brandVisibilityScore: "75%",
    organicVsSponsored: "50% Organic, 50% Sponsored",
    averageCpc: "$1.50",
    clickShare: "12%",
    historicalTrends: "Rising",
  },
  {
    brandVisibilityScore: "85%",
    organicVsSponsored: "70% Organic, 30% Sponsored",
    averageCpc: "$1.10",
    clickShare: "12%",
    historicalTrends: "Declining",
  },
  {
    brandVisibilityScore: "75%",
    organicVsSponsored: "55% Organic, 45% Sponsored",
    averageCpc: "$1.40",
    clickShare: "20%",
    historicalTrends: "Stable",
  },
  {
    brandVisibilityScore: "90%",
    organicVsSponsored: "80% Organic, 20% Sponsored",
    averageCpc: "$0.95",
    clickShare: "10%",
    historicalTrends: "Rising",
  },
];

const adsTimeBudgetData = [
  {
    campaignName: "Campaign A (SP)",
    budgetConsumption: "$2,500	",
    budgetDepletionRate: "80%",
    missedImpressions: "2,000	",
    bestPerformingHours: "9 AM - 12 PM",
    conversionRate: "5%",
  },
  {
    campaignName: "Campaign B (SB)",
    budgetConsumption: "$1,800	",
    budgetDepletionRate: "70%",
    missedImpressions: "1,500	",
    bestPerformingHours: "3 PM - 6 PM",
    conversionRate: "6%",
  },
  {
    campaignName: "Campaign C (SD)",
    budgetConsumption: "$3,000	",
    budgetDepletionRate: "85%",
    missedImpressions: "2,500	",
    bestPerformingHours: "12 PM - 3 PM",
    conversionRate: "6%",
  },
  {
    campaignName: "Campaign D (SP)",
    budgetConsumption: "$2,200	",
    budgetDepletionRate: "65%",
    missedImpressions: "1,800	",
    bestPerformingHours: "6 PM - 9 PM	",
    conversionRate: "4.5%",
  },
  {
    campaignName: "Campaign E (SB)",
    budgetConsumption: "$1,900	",
    budgetDepletionRate: "75%",
    missedImpressions: "2,000	",
    bestPerformingHours: "9 PM - 12 AM",
    conversionRate: "5.2%",
  },
];

const asinData = [
  {
    asin: "B0012345",
    searchQueries: "{search-query}, {search-query}",
    clickShare: "18%",
    purchaseRate: "5%",
    searchVolumeTrends: "Stable",
    rankingPosition: "1",
  },
  {
    asin: "B0012345",
    searchQueries:
      "{search-query}, {search-query}, {search-query}, {search-query},  {search-query}, {search-query}",
    clickShare: "18%",
    purchaseRate: "3%",
    searchVolumeTrends: "Declining",
    rankingPosition: "1",
  },
  {
    asin: "B0012345",
    searchQueries: "{search-query}, {search-query}",
    clickShare: "18%",
    purchaseRate: "4%",
    searchVolumeTrends: "Rising",
    rankingPosition: "1",
  },
  {
    asin: "B0012345",
    searchQueries: "{search-query}, {search-query}",
    clickShare: "18%",
    purchaseRate: "6%",
    searchVolumeTrends: "Stable",
    rankingPosition: "1",
  },
  {
    asin: "B0012345",
    searchQueries: "{search-query}, {search-query}, {search-query}",
    clickShare: "18%",
    purchaseRate: "2%",
    searchVolumeTrends: "Declining",
    rankingPosition: "1",
  },
];

const brandData = [
  {
    searchTerm: "{search-term}",
    searchVolume: "50,000",
    clickShare: "15%",
    conversionRate: "5%",
    topAsins: "B0012345, B0012348",
    sov: "20%",
    totalSales: "$10,000",
  },
  {
    searchTerm: "{search-term}",
    searchVolume: "30,000",
    clickShare: "15%",
    conversionRate: "5%",
    topAsins: "B0012345, B0012348",
    sov: "20%",
    totalSales: "$10,000",
  },
  {
    searchTerm: "{search-term}",
    searchVolume: "40,000",
    clickShare: "15%",
    conversionRate: "5%",
    topAsins: "B0012347, B0012348, B0012349",
    sov: "20%",
    totalSales: "$10,000",
  },
  {
    searchTerm: "{search-term}",
    searchVolume: "40,000",
    clickShare: "15%",
    conversionRate: "5%",
    topAsins: "B0012348, B0012345, B0012341, B0012349",
    sov: "20%",
    totalSales: "$10,000",
  },
  {
    searchTerm: "{search-term}",
    searchVolume: "25,000",
    clickShare: "15%",
    conversionRate: "5%",
    topAsins: "B0012345, B0012348",
    sov: "20%",
    totalSales: "$10,000",
  },
];

const skuData = [
  {
    key: uuid(),
    asin: "B07KM4MYZ",
    dateStart: "01.01.2024",
    dateEnd: "07.01.2024",
    cogs: "$9.50",
    price: "$11,000",
    contributionProfit: "$4,200.00",
    unitsSold: 372,
    unitsReturned: "$2,450",
    netProceeds: "$3,000",
    netMargin: "$150.25",
    amazonFee: "$2,450",
    fbaFee: "$3,000",
    refundFee: "$150.25",
  },
  {
    key: uuid(),
    asin: "B07KM4MYZ",
    dateStart: "01.01.2024",
    dateEnd: "07.01.2024",
    cogs: "$9.50",
    price: "$11,000",
    contributionProfit: "$4,200.00",
    unitsSold: 372,
    unitsReturned: "$2,450",
    netProceeds: "$3,000",
    referalFee: "$2,450",
    monthlyFee: "$3,000",
  },
  {
    key: uuid(),
    asin: "B07KM4MYZ",
    dateStart: "01.01.2024",
    dateEnd: "07.01.2024",
    cogs: "$9.50",
    price: "$11,000",
    unitsSold: 372,
    netProceeds: "$3,000",
    amazonFee: "$2,450",
  },
  {
    key: uuid(),
    asin: "B07KM4MYZ",
    dateStart: "01.01.2024",
    dateEnd: "07.01.2024",
    cogs: "$9.50",
    price: "$11,000",
    contributionProfit: "$4,200.00",
    unitsSold: 372,
    unitsReturned: "$2,450",
    netProceeds: "$3,000",
    netMargin: "$150.25",
    amazonFee: "$2,450",
    fbaFee: "$3,000",
    refundFee: "$150.25",
  },
];

const SearchQueryCOGSData = [
  {
    product: "Product 1",
    currency: "USD",
    cogs: "$20.50",
    startDate: "01.01.2024",
    endDate: "31.12.2024",
    miscellaneous: "25.00",
    total: "$50.00",
  },
  {
    product: "Product 2",
    currency: "EUR",
    cogs: "$25.75",
    startDate: "01.02.2024",
    endDate: "30.11.2024",
    miscellaneous: "30.00",
    total: "$60.00",
  },
  {
    product: "Product 3",
    currency: "USD",
    cogs: "$18.40",
    startDate: "15.01.2024",
    endDate: "15.12.2024",
    miscellaneous: "20.50",
    total: "$45.00",
  },
  {
    product: "Product 4",
    currency: "USD",
    cogs: "$22.10",
    startDate: "01.03.2024",
    endDate: "31.10.2024",
    miscellaneous: "28.00",
    total: "$55.00",
  },
  {
    product: "Product 5",
    currency: "EUR",
    cogs: "$19.90",
    startDate: "01.04.2024",
    endDate: "30.09.2024",
    miscellaneous: "25.00",
    total: "$50.00",
  },
];

type GroupOptions = { value: string; label: string }[];

export function buildGroup(
  data: Record<string, any>,
  prefix: string,
  count: number,
  options: GroupOptions,
): Record<string, { value: number }> {
  return Array.from({ length: count }, (_, i) => i + 1).reduce(
    (acc: Record<string, { value: number }>, idx) => {
      const typeValue = data[`${prefix}${idx}Type`];
      const rawValue = data[`${prefix}${idx}Value`];
      if (typeValue != null) {
        const opt = options.find((o) => o.value === typeValue);
        const key = opt?.label ?? typeValue;
        acc[key] = { value: Number(rawValue) || 0 };
      }
      return acc;
    },
    {},
  );
}
